import React, { useState } from "react";
import Head from "../../../layout/head/Head";
import Content from "../../../layout/content/Content";
import { 
    Card, 
    FormGroup, 
    Label, 
    Input, 
    Spinner 
} from "reactstrap";
import {
    Button,
    Block,
    BlockBetween,
    BlockHead,
    BlockHeadContent,
    BlockTitle,
    Row,
    Col,
} from "../../../components/Component";
import { loginAxios } from '../../../config/axios.config';
import { useMutation } from "@tanstack/react-query";
import { toast, ToastContainer } from "react-toastify";

const JewelleryDsrReport = () => {

    console.log(localStorage);
    const [dateRange, setDateRange] = useState({
        startDate: "",
        endDate: ""
    });

    const handleDateChange = (e) => {
        const { name, value } = e.target;
        setDateRange(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const generateReportApi = async (data) => {
        try {
            const response = await loginAxios.get(`reports/jewellery-dsr-report?startDate=${data.startDate}&endDate=${data.endDate}&name=Jewellery%20DSR%20Report&is_partial=0`, {
                headers: {
                    'x-auth-token': localStorage.getItem('accessToken')
                }
            });
            return response.data; 
        } catch (error) {
            const msg = error?.response?.data?.message || "Something went wrong";
            toast.error(msg);
            throw error;
        }
    };
    const downloadMutation = useMutation(generateReportApi, {
        onSuccess: (data) => {
            const fileUrl = data?.data?.file_path; 

            if (fileUrl) {
                const link = document.createElement('a');
                link.href = fileUrl;
                link.setAttribute('download', 'Jewellery_DSR_Report.csv'); 
                link.setAttribute('target', '_blank'); 
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                
                toast.success("File downloaded successfully!");
            } else {
                toast.warning("File URL not found in response.");
            }
        },
        onError: (error) => {
            console.error("Download failed", error);
        }
    });

    const handleDownload = () => {
        if (!dateRange.startDate || !dateRange.endDate) {
            toast.error("Please select both Start Date and End Date");
            return;
        }
        downloadMutation.mutate(dateRange);
    };

    return (
        <>
            <Head title="Jewellery DSR Report"></Head>

            <Content>
                <BlockHead size="sm">
                    <BlockBetween>
                        <BlockHeadContent>
                            <BlockTitle>Daily Sales Register Report</BlockTitle>
                            <p>Select a date range to download the DSR report.</p>
                        </BlockHeadContent>
                    </BlockBetween>
                </BlockHead>

                <Block>
                    <Card className="card-bordered card-stretch p-4">
                        <Row className="gy-4">
                            <Col md="4">
                                <FormGroup>
                                    <Label htmlFor="startDate" className="form-label">Start Date</Label>
                                    <div className="form-control-wrap">
                                        <Input
                                            type="date"
                                            id="startDate"
                                            name="startDate"
                                            value={dateRange.startDate}
                                            onChange={handleDateChange}
                                        />
                                    </div>
                                </FormGroup>
                            </Col>

                            <Col md="4">
                                <FormGroup>
                                    <Label htmlFor="endDate" className="form-label">End Date</Label>
                                    <div className="form-control-wrap">
                                        <Input
                                            type="date"
                                            id="endDate"
                                            name="endDate"
                                            value={dateRange.endDate}
                                            onChange={handleDateChange}
                                        />
                                    </div>
                                </FormGroup>
                            </Col>

                            <Col md="4" className="d-flex align-items-end">
                                <FormGroup>
                                    <Button 
                                        color="primary" 
                                        size="lg" 
                                        onClick={handleDownload}
                                        disabled={downloadMutation.isLoading}
                                    >
                                        {downloadMutation.isLoading ? (
                                            <>
                                                <Spinner size="sm" color="light" className="me-1" /> 
                                                Processing...
                                            </>
                                        ) : (
                                            "Download Report"
                                        )}
                                    </Button>
                                </FormGroup>
                            </Col>
                        </Row>
                    </Card>
                </Block>
            </Content>

            <ToastContainer />
        </>
    );
};

export default JewelleryDsrReport;